/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: BI Dashboard
 *| (C) Copyright IBM Corp. 2019
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
define([
], () => {

	/**
	 * This Class does Query result response post-processing such as processing the original query result
	 * into a data structure that is required by GeoInfo, Data for small multiples visualization etc.
	 **/
	class QueryPostProcessor {

		/*
		 * @Constructor
		 * @param {Object} options
		 *		options.queryResultData  QueryResultData object that is to be processed
		 */
		constructor(options) {

			/* Process Information, such as now of clipped data rows */
			this._processInfo = null;
			this._queryResultData = options.queryResultData;
		}

		destroy() {
			for (let prop in this) {
				// clear everything referenced by this object in case someone is still holding on to it.
				if (Object.prototype.hasOwnProperty.call(this, prop) && this[prop]) {
					delete this[prop];
				}
			}
		}

		/**
		 *@return {QueryResultData}
		 *
		 *To be overridden by child class
		 **/
		_processData() {
			this._setProcessInfo(null); /*Set process info depending on the process*/
			return this._queryResultData; /*processed data*/
		}

		_getProcessInfo() {
			return this._processInfo;
		}

		_setProcessInfo(info) {
			this._processInfo = info;
		}

		processData() {
			return {
				'result': this._processData(),
				'info': this._getProcessInfo()
			};
		}
	}

	return QueryPostProcessor;
});
